export const ACTIONS_PREFIX = 'subscription.userView.actions';
export const DRAWER_PREFIX = `${ACTIONS_PREFIX}.upgrade.drawer`;
export const FEATURE_PREFIX = 'subscription.userView.features';
export const LOSING_FEATURES_PREFIX = `subscription.userView.actions.losingFeatures`;
export const TIMELINE_PREFIX = `subscription.timelineTable`;
export const MAIN_TAB_PREFIX = `subscription.mainTab`;
export const MAIN_TAB_SIDEBAR_PREFIX = `${MAIN_TAB_PREFIX}.sidebar`;
export const MAIN_TAB_PAYMENT_VIEW = `${MAIN_TAB_PREFIX}.paymentView`;
export const ORGANIZATION_INFO_PREFIX = `${MAIN_TAB_PAYMENT_VIEW}.organizationInfo`;
export const SIDE_BAR_SIZE = '510px';
export const HEADER_SIZE = '200px';
export const PATH_FINDER_FEEDBACK_CHANNEL = 'C08UV9R55J7';
